export enum TerminationType {
  WITHDRAW = 'Renoncer',
  TERMINATE = 'Résilier',
  CANCEL = 'Se rétracter',
}

export const TERMINATION_TYPE: Record<TerminationType, string> = {
  [TerminationType.WITHDRAW]: 'RENONCER',
  [TerminationType.TERMINATE]: 'RESILIER',
  [TerminationType.CANCEL]: 'SE RETRACTER',
};
